<!-- <div id="container" style="height: 600px;"></div> -->
<div *ngIf="show">
 <highcharts-chart
      [Highcharts]="Highcharts"
      [options]="chartOptions"
      [constructorType]="chartConstructor"
      style="width: 100%; height: 70vh; display: block;"
    ></highcharts-chart>
</div>

